export default __webpack_public_path__ + "static/7-7d8de817c9b800efc9dbeb84b6176fad.png";